import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What the Clients sub-header still reads from the workspace: the open Clients section (also driven by the URL and the sections themselves) and the firm's custom labels.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmClientsSubnavHost = Pick<
  PmWorkspaceComponent,
  | 'clientsWorkspaceSection'
  | 'getCustomLabel'
  | 'setClientsWorkspaceSection'
>;

export const PM_CLIENTS_SUBNAV_HOST = new InjectionToken<PmClientsSubnavHost>('PmClientsSubnavHost');
